import script from "./Faq.vue?vue&type=script&setup=true&lang=js"
export * from "./Faq.vue?vue&type=script&setup=true&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=0751ce2b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0751ce2b"]])

export default __exports__